import { Category } from "../types";
import styles from "./styles.module.scss";

const StoreLinks = () => (
	<div className={styles.storeBtns}>
		<a href="https://plaoogle.com/store/apps/details?id=com.honda.ms.dm.sab" target="_blank" style={{ backgroundColor: "rgb(255,255,255)", maxWidth: "160px" }}>
			<img src="/roadsync/googleplay.png" height="40" /></a><a href="https://apps.apple.com/in/app/honda-roadsync/id1575345943" style={{ backgroundColor: "rgb(255,255,255)", maxWidth: "160px;" }} target="_blank"><img src="/roadsync/applestore.png" height="40" />
		</a>
	</div>
);

export const faqData: Category[] = [{
	title: "About Honda Roadsync",
	items: [
		{
			question: "What is Honda RoadSync?",
			content: <><p>Honda RoadSync is a smartphone app that connects your smartphone and motorcycle, and enables you to control your smartphone using the handlebar switch on your motorcycle, and voice control by connecting your smartphone and motorcycle via Bluetooth.</p></>
		},
		{
			question: "What functions does the Honda RoadSync app have?",
			content: <><p>Honda RoadSync app provides navigation, messaging, hands-free voice calls, music, and weather reports for the current location and destination, while you are riding your motorcycle. The functions that can be used while not riding will be updated as well.</p></>
		},
		{
			question: "Does Honda RoadSync have voice recognition?",
			content: <><p>Yes, it does. To use Honda RoadSync’s voice recognition, you need to prepare a headset with audio input/output.</p>
				<p>* For the iOS app, some voice recognition features are limited due to limitations of the iOS system.</p></>
		},
		{
			question: "What do I need to use the Honda Smartphone Voice Control system?",
			content: <><p>You need a compatible motorcycle, and the Honda RoadSync app installed on your smartphone. You also need a Bluetooth headset suitable for motorcycle riding. Please ask the salesperson about the details at a Honda dealer.</p><p>* To use voice recognition, you need a headset with audio input.</p></>
		},
		{
			question: "Which headsets are compatible with this system? Does Honda recommend any headsets?",
			content: <><p>Selected headsets that are compatible with your smartphone. Please ask the salesperson at a Honda dealer.</p></>,
		},
		{
			question: "I purchased a model that is not compatible with the Honda Smartphone Voice Control system. Can I add the functionality later?",
			content: <><p>Honda does not offer systems to retrofit Honda Smartphone Voice Control system.</p></>
		},
		{
			question: "In which countries can the Honda RoadSync app be used?",
			content: <><p>Please refer to <a href="https://globaonda/en/voice-control-system/">this page.</a></p></>
		},
		{
			question: "Which languages are supported?",
			content: <>
				<p>Honda RoadSync currently supports more than 20 languages as display language. Please look at ”App language” in the Advanced Settings menu of the Honda RoadSync app</p>
				<p>The supported language for voice feedback depends on the text-to-speech engine of your smartphone. For example, the default engine for Android devices is Google TTS. You can change the voice feedback language in "Text-to-speech language" of the Advanced Setting menu of the Honda RoadSync app.</p>
			</>,
		},
		{
			question: "Is Honda RoadSync compatible with iPhone (iOS)?",
			content: <>Currently, the iOS version of the Honda RoadSync app can be used in the same countries as the Android version.</>
		},
	]
},
{
	title: "Installing Honda RoadSync",
	items: [
		{
			question: "Where can I download Honda RoadSync?",
			content: <><p>You can download Honda RoadSync from the Google Play Store and the Apple App Store, shown below.</p><StoreLinks /></>,
		},
		{
			question: "What smartphone models / OS are compatible with the Honda RoadSync app?",
			content: <><p>Honda RoadSync is supported by devices with the following requirements: </p>
				<ul>
					<li>Android: The latest 5 versions(For example: Android 10 - 14),</li>
					<li>iOS: The latest 3 versions(For example: iOS 15 - 17),</li>
					<li>Bluetooth: BLE 4.2 or later</li>
				</ul>
				<p> To confirm whether the app is supported by your smartphone or not, please click the Google Play or App Store links, both shown below.</p>
				<ul>
					<li><i>The compatible smartphone models may depend on OS updates.</i></li>
					<li><i>Honda has not tested all smartphone models.</i></li>
					<li><i>Honda plans on increasing the number of compatible smartphones via updates to Honda RoadSync.</i></li>
				</ul>
				<StoreLinks />
			</>
		},
		{
			question: "Does it cost to use Honda RoadSync?",
			content: <><p>Honda RoadSync is free of charge to download and use.</p>
				<p> <i>* Subscription fees may apply for music apps connected to Honda RoadSync, and smartphone data usage.</i></p> </>
		}
	]
},
{
	title: "Connecting your smartphone via Bluetooth",
	items: [
		{
			question: "How can I connect via Bluetooth?",
			content: <><p>Please refer to the tutorial inside the Honda RoadSync App. The tutorial can be seen during the first time you open the App, and then accessed from the "Quick Settings" menu.</p></>,
		},
		{
			question: "Do I need to set up an ID in the Honda RoadSync app?",
			content: <>
				<p>You need a Google account or an Apple ID account for the initial app configuration.</p>
			</>
		},
		{
			question: "Why do I have to grant the app various permissions?",
			content: <>
				<p>The Honda RoadSync app needs to be granted various permissions in order to access and operate data and functions required for infotainment features, such as navigation, voice calls, messaging and music. These features will not be available if the required permissions are not granted. Regarding "access device's location", the reason why it needs "Allow all the time" is that the Honda RoadSync app works as a background app even if the smartphone is locked.</p>
			</>,
		},
		{
			question: "What are the points not to fail the Bluetooth connection?",
			content:
				<>
					<p>Don’t connect through Bluetooth directly to the vehicle without using the Honda RoadSync app. Please connect via Bluetooth to the vehicle by using the instructions of the app.</p>
					<h5>iOS</h5>
					<p> Additionally, please make sure the user is not already paired to the vehicle on the device before pairing.</p>
					<ol>
						<li>Go to the Bluetooth menu in the setting app.</li>
						<li>Find the user’s vehicle and tap the “i” button</li>
						<li>Tap “Forget This Device” and then tap “Confirm” in the dialog box.</li>
					</ol>
				</>
		},
		{
			question: "Can multiple smartphones be connected simultaneously? How many smartphones can be connected?",
			content: <><p>Only one smartphone can be connected to your vehicle’s Bluetooth unit at a time. To connect smartphones that have not been registered with the vehicle’s Bluetooth unit, please reset the bike’s Bluetooth settings first.</p></>
		}
	]
},
{
	title: "Using Honda RoadSync",
	items: [
		{
			question: "Can the smartphone screen be displayed while using the Honda RoadSync app ?",
			content: <><p>By consenting to the Safety Warning on screen, your smartphone screen can be displayed while it is connected to your motorcycle via Bluetooth.</p></>
		},
		{
			question: "How can I operate the handlebar switches in order to use Honda RoadSync?",
			content: <><p>Please see the tutorial of the Honda RoadSync app.</p></>
		},
		{
			question: "The handlebar switch does not activate the app.",
			content: <>
				<p>Please check the Bluetooth connection first.</p>
				<p> There are two types of meter modes on TFT type motorcycles: "Honda RoadSync mode" and "Default Mode". Once connected to the Honda RoadSync app, the meter automatically changes to "Honda RoadSync mode". Long-pressing the right button on the handlebar switch turns it into "Default Mode". Long-pressing the left button on the handlebar switch turns it into "Honda RoadSync mode". You can check how to operate the handlebar switch in the app tutorial.</p>
			</>
		},
		{
			question: "Where should I place my smartphone?",
			content: <><p>To ensure a safe operation and to avoid dropping your smartphone, please keep your smartphone not on the motorcycle but on yourselour smartphone is connected wirelessly by Bluetooth and can be operated via the handlebar switch and voice control.</p></>
		},
		{
			question: "Which commands can I use with voice recognition?",
			content: <>
				<p>You can use voice recognition to search for destinations and contacts, as well as input messageoice commands like Google Assistant are not supported.</p>
				<h5>iOS</h5>
				<p>
					The voice recognition feature can be used only for inputting text using your voice when searching the destination due to limitations of the iOS system.
				</p>
			</>
		},
		{
			question: "Which navigation apps are supported?",
			content: <>
				<h5>Android</h5>
				<p>Google Maps is supported for navigation.</p>
				<h5>iOS</h5>
				<p>The navigation service is provided by HERE Technologies.</p>
			</>
		},
		{
			question: "Is turn-by-turn navigation displayed on the TFT meter?",
			content: <>
				<p>Yes, by anticipating the road conditions and usage of users around the world, we have improved the guidance methods. Besides the voice assistance, we have added easy-to-understand visual indications (Turn-by-Turn function) in order to improve user convenience.</p></>
		},
		{
			question: "Can I use 3rd party apps (WhatsApp, LINE etc.) for calling?",
			content: <>
				<h5>Android</h5>
				<p> You can't operate 3rd party apps for calling via the Honda RoadSync app. You can call by using a default calling application.</p>
				<h5>iOS</h5>
				<p> Placing calls is not supported due to limitations of the iOS system.</p>
			</>,
		},
		{
			question: "What kind of messaging apps can be used?",
			content: <>
				<h5>Android</h5>
				<p>Please see "Choose supported message apps" in the Advanced settings.</p>
				<p>Only SMS is supported for new message creatioou can reply to your received message with any supported message application.</p>
				<h5>iOS</h5>
				<p>Please see "Choose supported message apps" in the Advanced settings.</p>
				<p>Only the feature of reading out the received messages is available due to limitations of the iOS system.</p>
			</>
		},
		{
			question: "How can I change the notification settings of the messaging app?",
			content: <>
				<p>You can change the messaging app in the Advanced setting of the Honda RoadSync apll supported messaging apps installed on your smartphone will appear in setting selections. The selected messaging apps will notify you about a new message during riding. Please refer to "What kind of messaging apps can be used?" above.</p></>
		},
		{
			question: "What kind of music apps can be used?",
			content: <>
				<h5>Android </h5>
				<p> Please see "Music Source" in the Advanced settings.</p>
				<h5> iOS </h5>
				<p> Currently, only Apple Music can be used due to limitations of the iOS system.</p>
			</>
		},
		{
			question: "How can I change the music app used on Honda RoadSync app?",
			content: <><h5>Android </h5>
				<p> You can change the music app in ”Music Source” in the Advanced setting of the Honda RoadSync apll supported music apps installed on your smartphone will appear as possible selections.</p>
				<h5>iOS </h5>
				<p> Currently, only Apple Music can be used due to limitations of the iOS system.</p>
			</>
		},
		{
			question: "Can I mute the sound?",
			content: <><p>You can mute the volume by long-pressing the down button on the handlebar switch - press this button again to unmute.</p></>
		},
		{
			question: "What are the meanings of each icon of the status bar in the TFT display?",
			content: <>
				<img src="/roadsync/tftmetepg" width="300" height="auto" title="TFTmeter" alt="TFTmeter" />
				<table>
					<tbody>
						<tr>
							<td>
								<img style={{ width: "31px" }} src="/roadsync/icon1.png" />
							</td>
							<td>
								<p>The bike and the smartphone are successfully connected via Bluetooth.</p>
							</td>
						</tr>
					</tbody>
				</table>
				<table>
					<tbody>
						<tr>
							<td>
								<img width="31" src="/roadsync/icon2.png" />
							</td>
							<td>
								<p>It is possible to use Honda RoadSync with the bike.</p>
							</td>
						</tr>
					</tbody>
				</table>
				<table>
					<tbody>
						<tr>
							<td>
								<img width="31" src="/roadsync/icon3.png" />
							</td>
							<td>
								<p>The smartphone has no online connectivity.</p>
							</td>
						</tr>
					</tbody>
				</table>
				<table>
					<tbody><tr>
						<td>
							<img width="31" src="/roadsync/icon4.png" />
						</td>
						<td>
							<p>The App is muted. (This can be changed by long-pressing the down button on the handlebar switch)</p>
						</td>
					</tr>
					</tbody>
				</table>
				<table>
					<tbody><tr>
						<td>
							<img width="31" src="/roadsync/icon5.png" />
						</td>
						<td>
							<p>Incoming call / Call in progress.</p>
						</td>
					</tr>
					</tbody>
				</table>
				<table>
					<tbody><tr>
						<td>
							<img width="31" src="/roadsync/icon6.png" />
						</td>
						<td>
							<p>Navigation guidance in progress.</p>
						</td>
					</tr>
					</tbody>
				</table>
				<table>
					<tbody><tr>
						<td>
							<img width="31" src="/roadsync/icon7.png" />
						</td>
						<td>
							<p>Music is playing.</p>
						</td>
					</tr>
					</tbody>
				</table>
				<table>
					<tbody>
						<tr>
							<td>
								<img width="31" src="/roadsync/icon8.png" />
							</td>
							<td>
								<p>The user has received new messages.</p>
							</td>
						</tr>
					</tbody>
				</table>
			</>
		},
		{
			question: "What is Trip History?",
			content: <>
				<p>While driving, your driving history is recorded automatically, and you can look back on it later.</p>
			</>
		},
		{
			question: "Which functions can I use without a headset?",
			content: <><p>You can connect your smartphone and motorcycle via Bluetooth, view the operation instructions in tutorial mode, add favorites and change the app settings, and so regarding the meter indication, when you receive a new message or call, you can see the indicator on the meter. As Honda RoadSync is designed for voice input and feedback, Honda recommends you to use the app with suitable motorcycle headsets.</p></>
		}, {
			question: "What functions can I use when my smartphone has no internet connection?",
			content: <><p>Without internet connection, you can connect the smartphone and motorcycle via Bluetooth, change the app settings, play local music and change the volume. However, the functions which need internet connection cannot work.</p></>
		},
		{
			question: "Can I stop Bluetooth from automatically connecting?",
			content: <><h5>Android </h5><p>Please set “Bluetooth Auto launch” to OFF in the Advanced settings of the Honda RoadSync app.</p>
				<h5>iOS</h5>
				<p>There are no settings related with Bluetooth auto launch.</p>
			</>
		},
		{
			question: "What is the difference between “Feedback language” and “App language” in the language settings?",
			content: <>
				<h5>Android </h5>
				<p>“App language”: Sets the language displayed on your screen. </p>
				<p>“Feedback language”: Sets the voice feedback languaglease check both language settings, as your preference for feedback language may be available even if it is not available as the app’s display language.</p>
				<h5> iOS </h5>
				<p> There are no setting items related to “Feedback language” and “App language”.</p>
			</>
		},
		{
			question: "How can I check the app version?",
			content: <>
				<p>You can check the app version on "Quick settings" &gt; "About" &gt; "App version" of the Honda RoadSync app.</p>
			</>
		},
		{
			question: "How do I shutdown the Honda RoadSync app?",
			content: <><h5>Android </h5>
				<p>
					If the Auto Connect / Disconnect setting is ON (default: ON), the app automatically shuts down once the motorcycle is OFF and the Bluetooth connection is terminated you shut it down from the app screen, please select Shutdown from Quick Settings.</p>
				<h5> iOS </h5>
				<p>
					There is no shutdown menu in the aphe app automatically shuts down once the motorcycle is OFF and the Bluetooth connection is terminated.
				</p>
			</>
		},

	]
},
{
	title: "Troubleshooting",
	items: [
		{
			question: "There is no sound.",
			content: <>
				<p>Have you muted the volume? If so, you can unmute by long-pressing the down button on the handlebar switch.</p>
			</>
		},
		{
			question: "The sound is small.",
			content: <>
				<p>Please check the volume level of your smartphone and your Bluetooth headset.</p>
			</>
		},
		{
			question: "Android - The voice feedback sound is smaller than other sounds.",
			content: <>
				<p>If you already set the volume to 100% and still are having difficulties hearing the voice feedback from the app, you can increase the Text-to-speech volume of your smartphone under the phone settings of "Accessibility"(Search "Text-to-speech" from the search bar of your smartphone's settings, find and activate "Amplify speech volume").</p>
				<p>(eg: Pixel4) Settings &gt; Accessibility &gt; Text-to-speech output &gt; Tap the Settings gear next to Preferred engine &gt; Amplify speech volume(on / off)</p>
			</>
		},
		{
			question: "Android - Text to speech does not work.",
			content: <>
				<p>With Samsung smartphone, the Samsung text-to-speech engine is selected as default, which may be the causlease try using the Google text-to-speech engine instead by changing the setting within the Honda RoadSync app.</p>
			</>
		},
		{
			question: "I cannot hear the beep sound to commence voice recognition.",
			content: <>
				<h5>Android </h5>
				<p>
					Please check the "Ring volume" of the volume settings of your smartphonhe beep sounds are controlled by the "Ring volume", and other functions are controlled by the "Media volume".</p>
				<h5> iOS </h5>
				<p> Please confirm the system volume to use the text input for searching any destination.</p>
			</>
		},
		{
			question: "The performance of the voice recognition is not good.",
			content: <>
				<p>The performance will depend on your environmeno improve the voice recognition, please try the following methods: </p>
				<ul>
					<li>Try to speak with a louder voice.</li>
					<li> Try to speak after the beep sound, which announces the timing for starting voice recognition.</li>
					<li> Check the language settings and set the language in which you will speak.</li>
					<li> The wind may affect your headset's microphone. Try to change the microphone's position, or use a full-face helmet.</li>
					<li> Try to use a headset which has good microphone specifications.</li>
				</ul>
			</>
		},
		{
			question: "Voice recognition does not work.",
			content: <>
				<p>Please confirm below: </p>
				<ul>
					<li>Try another voice recognition services, such as Google Assistant.</li>
					<li> Make sure that your Bluetooth headset is connected correctly, and that the microphone has been enabled.</li>
					<li> Try disconnecting your Bluetooth headset and see if voice recognition works via your smartphone’s microphone.</li>
					<li> The performance of the voice recognition can be affected by wind noise while ridinry wearing a full-face helmet to avoid wind noise.</li>
				</ul>
			</>
		},
		{
			question: "Weather that is not from my current location is being read aloud.",
			content: <>
				<p>If you check the weather with the destination set in "Navigation", you will hear the weather forecast of your destinatiof you cancel "Navigation", you will hear the weather forecast at your current location.</p>
			</>
		},
		{
			question: "The weather information does not finish loading.",
			content: <>
				<p>Please verify if your smartphone is connected to the internery using other apps that require a network connection to see if you are connected.</p>
			</>
		},
		{
			question: "I get “No results” when using voice search for navigation.",
			content: <>
				<p>The destination name may not be available for searchinlease try another destination.</p>
			</>
		},
		{
			question: "I get “No results” when searching nearby places for navigation",
			content: <>
				<p>There is the possibility that the destination name may not be available for searchinlease try another destination.</p>
			</>
		},
		{
			question: "Android - I get a Navigation error.",
			content: <>
				<p>Please go to Android Settings ＞ App ＞ Google Maps App and check the following steps: </p>
				< ol >
					<li>"Notifications" ＞ Check that all notifications are on.</li>
					<li> "Battery" ＞ Make sure it is "Unrestricted".</li>
					<li> "Data connection" ＞ Make sure that "Allow data usage in background" is active.</li>
					<li> We also recommend that you restart your smartphone so that Google Maps app is also restarted.</li>
				</ol>
			</>
		},
		{
			question: "I cannot play music.",
			content: <>
				<p>Please select a music app in the settings screen of Honda RoadSync app and make sure your music app can start playing in the backgrounf music cannot be played on the music app, please start the music app so that it can be played and then operate it via the Honda RoadSync app.</p>
			</>
		},
		{
			question: "'No network error' has occurred.",
			content: <>
				<p>Please make sure your smartphone is connected to the internet and try other apps that require a network connection to see if you are online.</p>
			</>
		},
		{
			question: "The app is frozen",
			content: <>
				<p>Please try to "Force stop" the apelow is the procedure of "Force stop".</p>
				< ol >
					<li>Long press the app's icon on the smartphone app list.</li>
					<li> Open "App info".</li>
					<li> Select "Force stop".</li>
				</ol>
			</>
		},
		{
			question: "Android - The Honda RoadSync app fails to auto-start after the vehicle starts.",
			content: <>
				<p>Make sure that the Honda RoadSync's "Autostart" setting is ON:</p>
				<ul>
					<li>[Settings] ＞[Apps] ＞[Manage apps] ＞[Honda RoadSync] </li>
					<li> [Autostart] &gt; ON </li>
				</ul>
				<p> Xiaomi or Redmi smartphone need to change specific settings: </p>
				<ul>
					<li>[Settings] ＞[Apps] ＞[Manage apps] ＞[Honda RoadSync] ＞[Other permissions] </li>
				</ul>
				<p> Please make sure the following 2 options are ON: </p>
				<ul>
					<li>Show on Lock screen </li>
					<li>Display pop-up windows while running in the background</li>
				</ul>
				<p>
					<img src="/roadsync/enng" alt="App settings" />
				</p>
			</>
		},
		{
			question: "Honda RoadSync does not work.",
			content: <>
				<p>Please contact our email support: <a href="mailto:contact@honda-roadsyn.com" > contact@honda-roadsync.com </a></p>
			</>
		},
		{
			question: "I cannot solve a problem, even if I have read the Frequently Asked Questions.",
			content: <>
				<p>Please contact our email support: <a href="mailto:contact@honda-roadsync.com" > contact@honda-roadsync.com </a></p>
			</>
		},
		{
			question: "I found a bug.",
			content: <>
				<p>Please contact our email support: <a href="mailto:contact@honda-roadsync.com" > contact@honda-roadsync.com </a></p>
			</>
		},
	]
},
{
	title: "Advanced topics",
	items: [
		{
			question: "What should I do if I move to another country?",
			content: <>
				<p>Please request the change of the country you reside in from ”Change my country of residence” of the app support.</p>
			</>
		},
		{
			question: "Is any personal information stored on the motorcycle?",
			content: <>
				<p>No personal information is stored on the motorcycle.</p>
			</>
		},
		{
			question: "Is there any chance my personal details will leak when I sell my motorcycle?",
			content: <>
				<p>As no personal information is stored on the motorcycle, your information cannot be leaked.</p>
			</>
		},
		{
			question: "How can I delete my account data of Honda RoadSync?",
			content: <>
				<p>Please inform us via the "Support" menu in the apfter selecting "Delete account", we will proceed to process and complete the account deletion automatically.</p>
			</>
		},
		{
			question: "I would like the information stored on the Honda RoadSync server to be disclosed.",
			content: <>
				<p>Please contact our email support: <a href="mailto:contact@honda-roadsynom">contact@honda-roadsync.com</a></p>
			</>
		}
	]
}];
